import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

// Optional: Define request type if any payload is sent (in this case, it's an empty POST body)
export interface CreateSetupIntentRequest extends Partial<AxiosRequestConfig> {
  headers?: {
    app?: "TRAVELLER" | "HOST"
    authorization: string
  }
}

// Define the expected response structure
export interface CreateSetupIntentResponse extends AxiosResponse {
  data: {
    data: {
      setupIntentClientSecret: string
    }
  }
}

// API function
export function createSetupIntentAPI(
  axiosInstance: AxiosInstance,
): Promise<CreateSetupIntentResponse> {
  return axiosInstance({
    method: "get",
    url: "/payment/setup-intent",
  }) as Promise<CreateSetupIntentResponse>
}
